// components/CostBreakdownTable.tsx
"use client";

import * as React from "react";
import {
    Box,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TableFooter,
} from "@mui/material";

export default function CostBreakdownTable({
    data,
    surfaceColor = "#f5f5f5",
    footerData = [{ item: "Total", amount: "16,000.00 (excluding insurance)" }],
}) {
    const borderColor = "#b1b1b1";

    return (
        <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
            <Box sx={{ position: "relative", width: "100%" }}>
                {/* left notch */}
                <Box
                    aria-hidden
                    sx={{
                        position: "absolute",
                        left: -9,
                        top: "21%", // matches dashed divider alignment
                        transform: "translateY(-50%)",
                        width: 18,
                        height: 18,
                        borderRadius: "50%",
                        bgcolor: surfaceColor,
                        borderRight: `1px solid ${borderColor}`,
                        zIndex: 2,
                        pointerEvents: "none",
                    }}
                />
                {/* right notch */}
                <Box
                    aria-hidden
                    sx={{
                        position: "absolute",
                        right: -9,
                        top: "21%",
                        transform: "translateY(-50%)",
                        width: 18,
                        height: 18,
                        borderRadius: "50%",
                        bgcolor: surfaceColor,
                        borderLeft: `1px solid ${borderColor}`,
                        zIndex: 2,
                        pointerEvents: "none",
                    }}
                />

                <TableContainer
                    component={Paper}
                    sx={{
                        overflow: "hidden",
                        borderRadius: 3,
                        boxShadow: "none",
                        border: `1px solid ${borderColor}`,
                        backgroundColor: "#fff",
                    }}
                >
                    <Table
                        sx={{
                            tableLayout: "fixed",
                            "& thead th:first-of-type, & tbody td:first-of-type, & tfoot td:first-of-type": {
                                borderRight: `1px solid ${borderColor}`,
                            },
                            "& thead th": { borderBottom: `1px solid ${borderColor}` },
                            "& tbody td": { borderBottom: `1px solid ${borderColor}` },
                            "& tbody tr:last-of-type td": { borderBottom: "none" },
                            "& tfoot td": { borderBottom: "none" },
                            "& th": { fontWeight: 700, textAlign: "center", py: 2 },
                            "& td": {
                                fontSize: 15,
                                fontWeight: 600,
                                py: 2,
                                textAlign: "center",
                            },
                            "& tbody td": {
                                color: "#4B5563",
                            },
                        }}
                    >
                        <colgroup>
                            <col style={{ width: "50%" }} />
                            <col style={{ width: "50%" }} />
                        </colgroup>

                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ fontSize: "16px" }}>Item</TableCell>
                                <TableCell sx={{ fontSize: "16px" }}>Amount (AED)</TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {data?.map((row, i) => (
                                <TableRow key={`row-${i}`}>
                                    <TableCell>{row.item}</TableCell>
                                    <TableCell>{row.amount}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>

                        <TableFooter>
                            {/* dashed divider */}
                            <TableRow>
                                <TableCell colSpan={2} sx={{ p: "0 !important" }}>
                                    <Box
                                        sx={{
                                            borderBottom: "2px dashed #D6DBE3",
                                            width: "100%",
                                        }}
                                    />
                                </TableCell>
                            </TableRow>
                            {footerData?.map((row, i) => (
                                <TableRow key={`total-${i}`}>
                                    <TableCell sx={{ color: "#000 !important" }}>
                                        {row.item}
                                    </TableCell>
                                    <TableCell sx={{ color: "#000 !important" }}>
                                        {row.amount}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableFooter>
                    </Table>
                </TableContainer>
            </Box>
        </Box>
    );
}
